export default __webpack_public_path__ + "images/84d1f8fae0f798ed51fc80e2b3e58324-master-card.svg";